export * from './program-item';
export * from './program-presenter';

import { ProgramItemComponent } from './program-item';
import { ProgramPresenterComponent } from './program-presenter';

export const ProgramAtoms = [
    ProgramItemComponent,
    ProgramPresenterComponent
];